import React from "react"

import SEO from "~components/shared/seo"
import PageNotFound from "~components/shared/page-not-found"

// eslint-disable-next-line import/no-unused-modules -- imported by gatsby
export default function NotFound() {
    return (
        <>
            <SEO title="404: Not found" />
            <PageNotFound />
        </>
    )
}
